import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';
import { TourAveragesData, TourAveragesVersion } from 'types/admin/tourAverages';

export const tourAveragesQueryKey = (version: TourAveragesVersion) => ['adminTourAverages', version] as const;

export const createEmptyTourAverages = (version: TourAveragesVersion): TourAveragesData => ({
  id: '',
  version,
  year: null,
  pga: [],
  lpga: [],
});

export const useTourAverages = (version: TourAveragesVersion) => {
  const service = useServices().tourAveragesEditorService;

  return useQuery<TourAveragesData | null, Error, TourAveragesData>({
    queryKey: tourAveragesQueryKey(version),
    queryFn: () => service.getTourAverages(version),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    select: (data) => data ?? createEmptyTourAverages(version),
  });
};
